interface JwtPayload {
    aud: string;
    exp: string;
    iss: string;
    jti: string;
    Email: string;
    'http://schemas.microsoft.com/ws/2008/06/identity/claims/role': string;
    FirstName: string;
    LastName: string;
    Id: string;
}

const Jwt = {
    Decode: (jwt: string): JwtPayload => {
        const tokens = jwt.split('.');
        const payload = atob(tokens[1]);
        return JSON.parse(payload);
    },
};

export default Jwt;
